module.exports = __webpack_public_path__ + "static/img/products_HoloData.55434e10.png";